import * as React from 'react';
import cn from 'classnames';
import Abuse from './icons/abuse';
import Accommodation from './icons/accommodation';
import AddSquare from './icons/add-square';
import AdminUser from './icons/admin-user';
import Alarmclock from './icons/alarmclock';
import Anchor from './icons/anchor';
import Application from './icons/application';
import ArrowBigDown from './icons/arrow-big-down';
import ArrowBigLeft from './icons/arrow-big-left';
import ArrowBigRight from './icons/arrow-big-right';
import ArrowBigUp from './icons/arrow-big-up';
import ArrowCornerTopLeft from './icons/arrow-corner-top-left';
import ArrowCornerTopLeftThick from './icons/arrow-corner-top-left-thick';
import ArrowLoop from './icons/arrow-loop';
import ArrowsSwap from './icons/arrows-swap';
import Asterisk from './icons/asterisk';
import AtSign from './icons/at-sign';
import AttachmentFiles from './icons/attachment-files';
import AudioVolumeOff from './icons/audio-volume-off';
import AudioVolumeOn from './icons/audio-volume-on';
import Baby from './icons/baby';
import BackArrow from './icons/back-arrow';
import BarcodeScan from './icons/barcode-scan';
import BarrierConstruction from './icons/barrier-construction';
import Bed from './icons/bed';
import Beta from './icons/beta';
import BinaryCode from './icons/binary-code';
import Bolt from './icons/bolt';
import Book from './icons/book';
import BookOpen from './icons/book-open';
import Bookmark from './icons/bookmark';
import BoxTruck from './icons/box-truck';
import Box from './icons/box';
import BreakDrinkNone from './icons/break-drink-none';
import Briefcase from './icons/briefcase';
import BrighhrApp from './icons/brighhr-app';
import BrightExchange from './icons/bright-exchange';
import Browser from './icons/browser';
import Bullhorn from './icons/bullhorn';
import Cake from './icons/cake';
import Calculator from './icons/calculator';
import CalendarBlackout from './icons/calendar-blackout';
import CalendarCross from './icons/calendar-cross';
import CalendarDates from './icons/calendar-dates';
import CalendarInfo from './icons/calendar-info';
import CalendarOverlap from './icons/calendar-overlap';
import CalendarTally from './icons/calendar-tally';
import Calendar from './icons/calendar';
import CameraAperture from './icons/camera-aperture';
import Camera from './icons/camera';
import CashBill from './icons/cash-bill';
import CashierTeller from './icons/cashier-teller';
import Certificate from './icons/certificate';
import Chair from './icons/chair';
import Chat from './icons/chat';
import CheckCircle from './icons/check-circle';
import Checkbox from './icons/checkbox';
import Checklist from './icons/checklist';
import ChevronCircleDown from './icons/chevron-circle-down';
import ChevronCircleLeft from './icons/chevron-circle-left';
import ChevronCircleRight from './icons/chevron-circle-right';
import ChevronCircleUp from './icons/chevron-circle-up';
import ChevronHollowDown from './icons/chevron-hollow-down';
import ChevronHollowLeft from './icons/chevron-hollow-left';
import ChevronHollowRight from './icons/chevron-hollow-right';
import ChevronHollowUp from './icons/chevron-hollow-up';
import ChevronThickDown from './icons/chevron-thick-down';
import ChevronThickLeft from './icons/chevron-thick-left';
import ChevronThickRight from './icons/chevron-thick-right';
import ChevronThickUp from './icons/chevron-thick-up';
import ChevronThinDown from './icons/chevron-thin-down';
import ChevronThinLeft from './icons/chevron-thin-left';
import ChevronThinRight from './icons/chevron-thin-right';
import ChevronThinUp from './icons/chevron-thin-up';
import Clear from './icons/clear';
import Clock from './icons/clock';
import ClothesHanger from './icons/clothes-hanger';
import Clothing from './icons/clothing';
import Cloud from './icons/cloud';
import Cog from './icons/cog';
import CommentBubble from './icons/comment-bubble';
import CommuteBoat from './icons/commute-boat';
import CommuteCar from './icons/commute-car';
import CommuteDeliveryVan from './icons/commute-delivery-van';
import CommuteRocket from './icons/commute-rocket';
import CommuteScooter from './icons/commute-scooter';
import Compass from './icons/compass';
import Compassionate from './icons/compassionate';
import Conflict from './icons/conflict';
import ContactCard from './icons/contact-card';
import Contrast from './icons/contrast';
import Copy from './icons/copy';
import Couch from './icons/couch';
import Court from './icons/court';
import Crib from './icons/crib';
import Crop from './icons/crop';
import CrossCircle from './icons/cross-circle';
import CrossThick from './icons/cross-thick';
import CrossThin from './icons/cross-thin';
import Cross from './icons/cross';
import Crown from './icons/crown';
import CurrencyDollar from './icons/currency-dollar';
import CurrencyEuro from './icons/currency-euro';
import CurrencyFranc from './icons/currency-franc';
import CurrencyGeneric from './icons/currency-generic';
import CurrencyPeso from './icons/currency-peso';
import CurrencyPound from './icons/currency-pound';
import CurrencyRuble from './icons/currency-ruble';
import CurrencyRupee from './icons/currency-rupee';
import CurrencyWon from './icons/currency-won';
import CurrencyYen from './icons/currency-yen';
import CurrencyYuan from './icons/currency-yuan';
import Cylinder from './icons/cylinder';
import DataSecurity from './icons/data-security';
import Dependants from './icons/dependants';
import Devices from './icons/devices';
import Dial from './icons/dial';
import Diamond from './icons/diamond';
import Diaper from './icons/diaper';
import DisabilityMobility from './icons/disability-mobility';
import Dna from './icons/dna';
import Door from './icons/door';
import DoubleTicks from './icons/double-ticks';
import DownArrow from './icons/down-arrow';
import Download2 from './icons/download-2';
import Download from './icons/download';
import Earphones from './icons/earphones';
import Edit from './icons/edit';
import Education from './icons/education';
import Emergency from './icons/emergency';
import EmployeeTerminated from './icons/employee-terminated';
import Enter from './icons/enter';
import Erase from './icons/erase';
import ErrorOctagon from './icons/error-octagon';
import Error from './icons/error';
import Exit from './icons/exit';
import Expand from './icons/expand';
import Explosion from './icons/explosion';
import FaCode from './icons/fa-code';
import Factory from './icons/factory';
import Featus from './icons/featus';
import FeedRss from './icons/feed-rss';
import FeedbackEmotionScale1 from './icons/feedback-emotion-scale-1';
import FeedbackEmotionScale2 from './icons/feedback-emotion-scale-2';
import FeedbackEmotionScale3 from './icons/feedback-emotion-scale-3';
import FeedbackEmotionScale4 from './icons/feedback-emotion-scale-4';
import FeedbackEmotionScale5 from './icons/feedback-emotion-scale-5';
import FeedbackLoop from './icons/feedback-loop';
import Feedback from './icons/feedback';
import FileAudio from './icons/file-audio';
import FileCode from './icons/file-code';
import FileDatabase from './icons/file-database';
import FileDocument from './icons/file-document';
import FileEmail from './icons/file-email';
import FileImage from './icons/file-image';
import FileMovie from './icons/file-movie';
import FilePath from './icons/file-path';
import FilePdf from './icons/file-pdf';
import FilePresentation from './icons/file-presentation';
import FileSpreadsheet from './icons/file-spreadsheet';
import FileText from './icons/file-text';
import FileVector from './icons/file-vector';
import Filter from './icons/filter';
import Fingerprint from './icons/fingerprint';
import FireExtinguisher from './icons/fire-extinguisher';
import Fire from './icons/fire';
import Flag from './icons/flag';
import FlashOff from './icons/flash-off';
import Flash from './icons/flash';
import FloorSignage from './icons/floor-signage';
import Flower from './icons/flower';
import FolderAdd from './icons/folder-add';
import FolderSolid from './icons/folder-solid';
import FolderZip from './icons/folder-zip';
import Folder from './icons/folder';
import Forklift from './icons/forklift';
import Fuel from './icons/fuel';
import FurloughNavigator from './icons/furlough-navigator';
import Gallery from './icons/gallery';
import GestureTouch from './icons/gesture-touch';
import Ghost from './icons/ghost';
import Gift from './icons/gift';
import Globe from './icons/globe';
import Grid from './icons/grid';
import Hashtag from './icons/hashtag';
import Headset from './icons/headset';
import Health from './icons/health';
import HeartFilled from './icons/heart-filled';
import Heart from './icons/heart';
import Help from './icons/help';
import Home from './icons/home';
import Hourglass from './icons/hourglass';
import IdCard from './icons/id-card';
import InboxEmpty from './icons/inbox-empty';
import Inbox from './icons/inbox';
import Infection from './icons/infection';
import Information from './icons/information';
import KeyboardBackspace from './icons/keyboard-backspace';
import KnifeFork from './icons/knife-fork';
import Labs from './icons/labs';
import Layout from './icons/layout';
import Leaf from './icons/leaf';
import LeftArrow from './icons/left-arrow';
import Legal from './icons/legal';
import Lifejacket from './icons/lifejacket';
import Lightbulb from './icons/lightbulb';
import Lightning from './icons/lightning';
import LineChart from './icons/line-chart';
import Link from './icons/link';
import ListApproved from './icons/list-approved';
import ListBullets from './icons/list-bullets';
import LocationList from './icons/location-list';
import LocationPin from './icons/location-pin';
import Loop from './icons/loop';
import Magicwand from './icons/magicwand';
import Magnet from './icons/magnet';
import Mail from './icons/mail';
import ManagerUser from './icons/manager-user';
import MandatoryLeave from './icons/mandatory-leave';
import Map from './icons/map';
import Medal from './icons/medal';
import MedicalBag from './icons/medical-bag';
import MedicalChart from './icons/medical-chart';
import Medical from './icons/medical';
import Medication from './icons/medication';
import Menu1X3Hollow from './icons/menu-1-x-3-hollow';
import Menu1X3Thick from './icons/menu-1-x-3-thick';
import Menu3X1Hollow from './icons/menu-3-x-1-hollow';
import Menu3X1Thick from './icons/menu-3-x-1-thick';
import MenuApps2x2 from './icons/menu-apps-2x2';
import MenuApps3x2 from './icons/menu-apps-3x2';
import MenuHamburgerThick from './icons/menu-hamburger-thick';
import MenuHamburger from './icons/menu-hamburger';
import MessageMobile from './icons/message-mobile';
import Message from './icons/message';
import Meteor from './icons/meteor';
import Microphone from './icons/microphone';
import MinusCircle from './icons/minus-circle';
import MinusSquare from './icons/minus-square';
import MinusThick from './icons/minus-thick';
import MinusThin from './icons/minus-thin';
import MoneyStack from './icons/money-stack';
import MoneyTick from './icons/money-tick';
import NewWindow from './icons/new-window';
import Newspaper from './icons/newspaper';
import Night from './icons/night';
import NotAllowed from './icons/not-allowed';
import Note from './icons/note';
import Notebook from './icons/notebook';
import Notepad from './icons/notepad';
import NotesAlt from './icons/notes-alt';
import Notifications from './icons/notifications';
import Offer from './icons/offer';
import OpenShifts from './icons/open-shifts';
import OrganisationConnection from './icons/organisation-connection';
import Pacman from './icons/pacman';
import PadlockLocked from './icons/padlock-locked';
import PadlockUnlocked from './icons/padlock-unlocked';
import PaperStack from './icons/paper-stack';
import Paperclip from './icons/paperclip';
import Parking from './icons/parking';
import Payroll from './icons/payroll';
import Pencil from './icons/pencil';
import Percentage from './icons/percentage';
import Person from './icons/person';
import Perspective from './icons/perspective';
import PhoneWork from './icons/phone-work';
import Phone from './icons/phone';
import Phonecall from './icons/phonecall';
import PieChart from './icons/pie-chart';
import Pin from './icons/pin';
import Plane from './icons/plane';
import Plaster from './icons/plaster';
import PlusCircle from './icons/plus-circle';
import PlusHollow from './icons/plus-hollow';
import PlusThick from './icons/plus-thick';
import PlusThin from './icons/plus-thin';
import Pop from './icons/pop';
import Power from './icons/power';
import Printer from './icons/printer';
import Propeller from './icons/propeller';
import Pulse from './icons/pulse';
import Puzzle from './icons/puzzle';
import QrCode from './icons/qr-code';
import QuestionMark from './icons/question-mark';
import Question from './icons/question';
import Radar from './icons/radar';
import RankInsignia from './icons/rank-insignia';
import Receipt from './icons/receipt';
import Reception from './icons/reception';
import Records from './icons/records';
import Refresh from './icons/refresh';
import Rename from './icons/rename';
import Requests from './icons/requests';
import Ribbon from './icons/ribbon';
import RightArrow from './icons/right-arrow';
import Road from './icons/road';
import RockingChair from './icons/rocking-chair';
import Rosette from './icons/rosette';
import Rotas from './icons/rotas';
import RotateDevice from './icons/rotate-device';
import RotateImage from './icons/rotate-image';
import Ruler from './icons/ruler';
import Rush from './icons/rush';
import SafeVault from './icons/safe-vault';
import SafetyBeaker from './icons/safety-beaker';
import SafetyBootsPpe from './icons/safety-boots-ppe';
import SafetyCone from './icons/safety-cone';
import SafetyFaceshieldPpe from './icons/safety-faceshield-ppe';
import SafetyGogglesPpe from './icons/safety-goggles-ppe';
import SafetyHardhat from './icons/safety-hardhat';
import SafetyInjury from './icons/safety-injury';
import SafetySlip from './icons/safety-slip';
import SafetyWashingPpe from './icons/safety-washing-ppe';
import Search from './icons/search';
import SecurityLock from './icons/security-lock';
import SecurityPin from './icons/security-pin';
import Send from './icons/send';
import SettingsSliders from './icons/settings-sliders';
import ShapeCircle from './icons/shape-circle';
import ShapePentagon from './icons/shape-pentagon';
import ShapeSquare from './icons/shape-square';
import ShapeTriangleUp from './icons/shape-triangle-up';
import Share from './icons/share';
import Shield from './icons/shield';
import Shifts from './icons/shifts';
import Shredder from './icons/shredder';
import SignalLoss from './icons/signal-loss';
import Signal from './icons/signal';
import Signature from './icons/signature';
import Skull from './icons/skull';
import SocialFacebook from './icons/social-facebook';
import SocialInstagram from './icons/social-instagram';
import SocialLinkedin from './icons/social-linkedin';
import SocialTwitter from './icons/social-twitter';
import SocialYoutube from './icons/social-youtube';
import SoftwareChrome from './icons/software-chrome';
import SortAscending from './icons/sort-ascending';
import SortDescending from './icons/sort-descending';
import Spanner from './icons/spanner';
import Stamp from './icons/stamp';
import StarFilled from './icons/star-filled';
import Star from './icons/star';
import Steam from './icons/steam';
import Stethoscope from './icons/stethoscope';
import Stop from './icons/stop';
import Stopwatch from './icons/stopwatch';
import Suitcase from './icons/suitcase';
import Sun from './icons/sun';
import Switcher from './icons/switcher';
import Syringe from './icons/syringe';
import TableGrid from './icons/table-grid';
import Table from './icons/table';
import Tachograph from './icons/tachograph';
import Tag from './icons/tag';
import Tally from './icons/tally';
import Target from './icons/target';
import Tasklist from './icons/tasklist';
import TechnologyLaptop from './icons/technology-laptop';
import Temperature from './icons/temperature';
import TerminatedDismissed from './icons/terminated-dismissed';
import ThumbsDown from './icons/thumbs-down';
import ThumbsUp from './icons/thumbs-up';
import TickCircle from './icons/tick-circle';
import TickThick from './icons/tick-thick';
import TickThin from './icons/tick-thin';
import TicketStub from './icons/ticket-stub';
import TimeCardReport from './icons/time-card-report';
import TimelineHistory from './icons/timeline-history';
import Timezones from './icons/timezones';
import ToilAdd from './icons/toil-add';
import Toil from './icons/toil';
import Tooth from './icons/tooth';
import Train from './icons/train';
import TrainingEvents from './icons/training-events';
import TranslationLanguages from './icons/translation-languages';
import Trash from './icons/trash';
import Tree from './icons/tree';
import TurboTalent from './icons/turbo-talent';
import Umbrella from './icons/umbrella';
import Unpaid from './icons/unpaid';
import UpArrow from './icons/up-arrow';
import Update from './icons/update';
import Upload from './icons/upload';
import UserAdd from './icons/user-add';
import UserAvatar from './icons/user-avatar';
import UserId from './icons/user-id';
import UserRemove from './icons/user-remove';
import User from './icons/user';
import Users from './icons/users';
import VacuumCleaner from './icons/vacuum-cleaner';
import Verified from './icons/verified';
import VideoControlsPause from './icons/video-controls-pause';
import VideoControlsPlayCircle from './icons/video-controls-play-circle';
import VideoControlsPlay from './icons/video-controls-play';
import Virus from './icons/virus';
import VisibilityNone from './icons/visibility-none';
import Visibility from './icons/visibility';
import Voucher from './icons/voucher';
import Wallet from './icons/wallet';
import Watch from './icons/watch';
import Xing from './icons/xing';
import ZoomIn from './icons/zoom-in';
import ZoomOut from './icons/zoom-out';
import DataTypeString from './icons/data-type-string';
import DataTypeNumber from './icons/data-type-number';
import DataTypeFloat from './icons/data-type-float';
import DataTypeBoolean from './icons/data-type-boolean';
import DataTypeDate from './icons/data-type-date';
import { IconNameType } from './iconType';

type IconSize = 'xxs' | 'xs' | 'sm' | 'base' | 'lg' | 'xl' | 'xxl';

export type IconProps = React.SVGAttributes<SVGElement> & {
	iconName: IconNameType;
	size?: IconSize | number;
	className?: string;
};

const iconSizes = {
	xxs: 12,
	xs: 16,
	sm: 24,
	base: 32,
	lg: 40,
	xl: 48,
	xxl: 56,
};

const iconSize = (size?: IconSize | number) => {
	if (typeof size === 'number') return size;
	return size ? iconSizes[size] : 32;
};

const Icon = ({
	iconName,
	size = 32,
	className = '',
	...props
}: IconProps): React.ReactElement => {
	const getIcon = () => {
		switch (iconName) {
			case 'abuse':
				return Abuse;
			case 'accommodation':
				return Accommodation;
			case 'add-square':
				return AddSquare;
			case 'admin-user':
				return AdminUser;
			case 'alarmclock':
				return Alarmclock;
			case 'anchor':
				return Anchor;
			case 'application':
				return Application;
			case 'arrow-big-down':
				return ArrowBigDown;
			case 'arrow-big-left':
				return ArrowBigLeft;
			case 'arrow-big-right':
				return ArrowBigRight;
			case 'arrow-big-up':
				return ArrowBigUp;
			case 'arrow-corner-top-left':
				return ArrowCornerTopLeft;
			case 'arrow-corner-top-left-thick':
				return ArrowCornerTopLeftThick;
			case 'arrow-loop':
				return ArrowLoop;
			case 'arrows-swap':
				return ArrowsSwap;
			case 'asterisk':
				return Asterisk;
			case 'at-sign':
				return AtSign;
			case 'attachment-files':
				return AttachmentFiles;
			case 'audio-volume-off':
				return AudioVolumeOff;
			case 'audio-volume-on':
				return AudioVolumeOn;
			case 'baby':
				return Baby;
			case 'back-arrow':
				return BackArrow;
			case 'barcode-scan':
				return BarcodeScan;
			case 'barrier-construction':
				return BarrierConstruction;
			case 'bed':
				return Bed;
			case 'beta':
				return Beta;
			case 'binary-code':
				return BinaryCode;
			case 'bolt':
				return Bolt;
			case 'book':
				return Book;
			case 'book-open':
				return BookOpen;
			case 'bookmark':
				return Bookmark;
			case 'box-truck':
				return BoxTruck;
			case 'box':
				return Box;
			case 'break-drink-none':
				return BreakDrinkNone;
			case 'briefcase':
				return Briefcase;
			case 'brighhr-app':
				return BrighhrApp;
			case 'bright-exchange':
				return BrightExchange;
			case 'browser':
				return Browser;
			case 'bullhorn':
				return Bullhorn;
			case 'cake':
				return Cake;
			case 'calculator':
				return Calculator;
			case 'calendar-blackout':
				return CalendarBlackout;
			case 'calendar-cross':
				return CalendarCross;
			case 'calendar-dates':
				return CalendarDates;
			case 'calendar-info':
				return CalendarInfo;
			case 'calendar-overlap':
				return CalendarOverlap;
			case 'calendar-tally':
				return CalendarTally;
			case 'calendar':
				return Calendar;
			case 'camera-aperture':
				return CameraAperture;
			case 'camera':
				return Camera;
			case 'cash-bill':
				return CashBill;
			case 'cashier-teller':
				return CashierTeller;
			case 'certificate':
				return Certificate;
			case 'chair':
				return Chair;
			case 'chat':
				return Chat;
			case 'check-circle':
				return CheckCircle;
			case 'checkbox':
				return Checkbox;
			case 'checklist':
				return Checklist;
			case 'chevron-circle-down':
				return ChevronCircleDown;
			case 'chevron-circle-left':
				return ChevronCircleLeft;
			case 'chevron-circle-right':
				return ChevronCircleRight;
			case 'chevron-circle-up':
				return ChevronCircleUp;
			case 'chevron-hollow-down':
				return ChevronHollowDown;
			case 'chevron-hollow-left':
				return ChevronHollowLeft;
			case 'chevron-hollow-right':
				return ChevronHollowRight;
			case 'chevron-hollow-up':
				return ChevronHollowUp;
			case 'chevron-thick-down':
				return ChevronThickDown;
			case 'chevron-thick-left':
				return ChevronThickLeft;
			case 'chevron-thick-right':
				return ChevronThickRight;
			case 'chevron-thick-up':
				return ChevronThickUp;
			case 'chevron-thin-down':
				return ChevronThinDown;
			case 'chevron-thin-left':
				return ChevronThinLeft;
			case 'chevron-thin-right':
				return ChevronThinRight;
			case 'chevron-thin-up':
				return ChevronThinUp;
			case 'clear':
				return Clear;
			case 'clock':
				return Clock;
			case 'clothes-hanger':
				return ClothesHanger;
			case 'clothing':
				return Clothing;
			case 'cloud':
				return Cloud;
			case 'cog':
				return Cog;
			case 'comment-bubble':
				return CommentBubble;
			case 'commute-boat':
				return CommuteBoat;
			case 'commute-car':
				return CommuteCar;
			case 'commute-delivery-van':
				return CommuteDeliveryVan;
			case 'commute-rocket':
				return CommuteRocket;
			case 'commute-scooter':
				return CommuteScooter;
			case 'compass':
				return Compass;
			case 'compassionate':
				return Compassionate;
			case 'conflict':
				return Conflict;
			case 'contact-card':
				return ContactCard;
			case 'contrast':
				return Contrast;
			case 'copy':
				return Copy;
			case 'couch':
				return Couch;
			case 'court':
				return Court;
			case 'crib':
				return Crib;
			case 'crop':
				return Crop;
			case 'cross-circle':
				return CrossCircle;
			case 'cross-thick':
				return CrossThick;
			case 'cross-thin':
				return CrossThin;
			case 'cross':
				return Cross;
			case 'crown':
				return Crown;
			case 'currency-dollar':
				return CurrencyDollar;
			case 'currency-euro':
				return CurrencyEuro;
			case 'currency-franc':
				return CurrencyFranc;
			case 'currency-generic':
				return CurrencyGeneric;
			case 'currency-peso':
				return CurrencyPeso;
			case 'currency-pound':
				return CurrencyPound;
			case 'currency-ruble':
				return CurrencyRuble;
			case 'currency-rupee':
				return CurrencyRupee;
			case 'currency-won':
				return CurrencyWon;
			case 'currency-yen':
				return CurrencyYen;
			case 'currency-yuan':
				return CurrencyYuan;
			case 'cylinder':
				return Cylinder;
			case 'data-type-string':
				return DataTypeString;
			case 'data-type-float':
				return DataTypeFloat;
			case 'data-type-boolean':
				return DataTypeBoolean;
			case 'data-type-date':
				return DataTypeDate;
			case 'data-type-number':
				return DataTypeNumber;
			case 'data-security':
				return DataSecurity;
			case 'dependants':
				return Dependants;
			case 'devices':
				return Devices;
			case 'dial':
				return Dial;
			case 'diamond':
				return Diamond;
			case 'diaper':
				return Diaper;
			case 'disability-mobility':
				return DisabilityMobility;
			case 'dna':
				return Dna;
			case 'door':
				return Door;
			case 'double-ticks':
				return DoubleTicks;
			case 'down-arrow':
				return DownArrow;
			case 'download-2':
				return Download2;
			case 'download':
				return Download;
			case 'earphones':
				return Earphones;
			case 'edit':
				return Edit;
			case 'education':
				return Education;
			case 'emergency':
				return Emergency;
			case 'enter':
				return Enter;
			case 'erase':
				return Erase;
			case 'error-octagon':
				return ErrorOctagon;
			case 'error':
				return Error;
			case 'exit':
				return Exit;
			case 'expand':
				return Expand;
			case 'explosion':
				return Explosion;
			case 'fa-code':
				return FaCode;
			case 'factory':
				return Factory;
			case 'featus':
				return Featus;
			case 'feed-rss':
				return FeedRss;
			case 'feedback-emotion-scale-1':
				return FeedbackEmotionScale1;
			case 'feedback-emotion-scale-2':
				return FeedbackEmotionScale2;
			case 'feedback-emotion-scale-3':
				return FeedbackEmotionScale3;
			case 'feedback-emotion-scale-4':
				return FeedbackEmotionScale4;
			case 'feedback-emotion-scale-5':
				return FeedbackEmotionScale5;
			case 'feedback-loop':
				return FeedbackLoop;
			case 'feedback':
				return Feedback;
			case 'file-audio':
				return FileAudio;
			case 'file-code':
				return FileCode;
			case 'file-database':
				return FileDatabase;
			case 'file-document':
				return FileDocument;
			case 'file-email':
				return FileEmail;
			case 'file-image':
				return FileImage;
			case 'file-movie':
				return FileMovie;
			case 'file-path':
				return FilePath;
			case 'file-pdf':
				return FilePdf;
			case 'file-presentation':
				return FilePresentation;
			case 'file-spreadsheet':
				return FileSpreadsheet;
			case 'file-text':
				return FileText;
			case 'file-vector':
				return FileVector;
			case 'filter':
				return Filter;
			case 'fingerprint':
				return Fingerprint;
			case 'fire-extinguisher':
				return FireExtinguisher;
			case 'fire':
				return Fire;
			case 'flag':
				return Flag;
			case 'flash-off':
				return FlashOff;
			case 'flash':
				return Flash;
			case 'floor-signage':
				return FloorSignage;
			case 'flower':
				return Flower;
			case 'folder-add':
				return FolderAdd;
			case 'folder-solid':
				return FolderSolid;
			case 'folder-zip':
				return FolderZip;
			case 'folder':
				return Folder;
			case 'forklift':
				return Forklift;
			case 'fuel':
				return Fuel;
			case 'furlough-navigator':
				return FurloughNavigator;
			case 'gallery':
				return Gallery;
			case 'gesture-touch':
				return GestureTouch;
			case 'ghost':
				return Ghost;
			case 'gift':
				return Gift;
			case 'globe':
				return Globe;
			case 'grid':
				return Grid;
			case 'hashtag':
				return Hashtag;
			case 'headset':
				return Headset;
			case 'health':
				return Health;
			case 'heart-filled':
				return HeartFilled;
			case 'heart':
				return Heart;
			case 'help':
				return Help;
			case 'home':
				return Home;
			case 'hourglass':
				return Hourglass;
			case 'id-card':
				return IdCard;
			case 'inbox-empty':
				return InboxEmpty;
			case 'inbox':
				return Inbox;
			case 'infection':
				return Infection;
			case 'information':
				return Information;
			case 'keyboard-backspace':
				return KeyboardBackspace;
			case 'knife-fork':
				return KnifeFork;
			case 'labs':
				return Labs;
			case 'layout':
				return Layout;
			case 'leaf':
				return Leaf;
			case 'left-arrow':
				return LeftArrow;
			case 'legal':
				return Legal;
			case 'lifejacket':
				return Lifejacket;
			case 'lightbulb':
				return Lightbulb;
			case 'lightning':
				return Lightning;
			case 'line-chart':
				return LineChart;
			case 'link':
				return Link;
			case 'list-approved':
				return ListApproved;
			case 'list-bullets':
				return ListBullets;
			case 'location-list':
				return LocationList;
			case 'location-pin':
				return LocationPin;
			case 'loop':
				return Loop;
			case 'magicwand':
				return Magicwand;
			case 'magnet':
				return Magnet;
			case 'mail':
				return Mail;
			case 'manager-user':
				return ManagerUser;
			case 'mandatory-leave':
				return MandatoryLeave;
			case 'map':
				return Map;
			case 'medal':
				return Medal;
			case 'medical-bag':
				return MedicalBag;
			case 'medical-chart':
				return MedicalChart;
			case 'medical':
				return Medical;
			case 'medication':
				return Medication;
			case 'menu-1-x-3-hollow':
				return Menu1X3Hollow;
			case 'menu-1-x-3-thick':
				return Menu1X3Thick;
			case 'menu-3-x-1-hollow':
				return Menu3X1Hollow;
			case 'menu-3-x-1-thick':
				return Menu3X1Thick;
			case 'menu-apps-2x2':
				return MenuApps2x2;
			case 'menu-apps-3x2':
				return MenuApps3x2;
			case 'menu-hamburger-thick':
				return MenuHamburgerThick;
			case 'menu-hamburger':
				return MenuHamburger;
			case 'message-mobile':
				return MessageMobile;
			case 'message':
				return Message;
			case 'meteor':
				return Meteor;
			case 'microphone':
				return Microphone;
			case 'minus-circle':
				return MinusCircle;
			case 'minus-square':
				return MinusSquare;
			case 'minus-thick':
				return MinusThick;
			case 'minus-thin':
				return MinusThin;
			case 'money-stack':
				return MoneyStack;
			case 'money-tick':
				return MoneyTick;
			case 'new-window':
				return NewWindow;
			case 'newspaper':
				return Newspaper;
			case 'night':
				return Night;
			case 'not-allowed':
				return NotAllowed;
			case 'note':
				return Note;
			case 'notebook':
				return Notebook;
			case 'notepad':
				return Notepad;
			case 'notes-alt':
				return NotesAlt;
			case 'notifications':
				return Notifications;
			case 'offer':
				return Offer;
			case 'open-shifts':
				return OpenShifts;
			case 'organisation-connection':
				return OrganisationConnection;
			case 'pacman':
				return Pacman;
			case 'padlock-locked':
				return PadlockLocked;
			case 'padlock-unlocked':
				return PadlockUnlocked;
			case 'paper-stack':
				return PaperStack;
			case 'paperclip':
				return Paperclip;
			case 'parking':
				return Parking;
			case 'payroll':
				return Payroll;
			case 'pencil':
				return Pencil;
			case 'percentage':
				return Percentage;
			case 'person':
				return Person;
			case 'perspective':
				return Perspective;
			case 'phone-work':
				return PhoneWork;
			case 'phone':
				return Phone;
			case 'phonecall':
				return Phonecall;
			case 'pie-chart':
				return PieChart;
			case 'pin':
				return Pin;
			case 'plane':
				return Plane;
			case 'plaster':
				return Plaster;
			case 'plus-circle':
				return PlusCircle;
			case 'plus-hollow':
				return PlusHollow;
			case 'plus-thick':
				return PlusThick;
			case 'plus-thin':
				return PlusThin;
			case 'pop':
				return Pop;
			case 'power':
				return Power;
			case 'printer':
				return Printer;
			case 'propeller':
				return Propeller;
			case 'pulse':
				return Pulse;
			case 'puzzle':
				return Puzzle;
			case 'qr-code':
				return QrCode;
			case 'question-mark':
				return QuestionMark;
			case 'question':
				return Question;
			case 'radar':
				return Radar;
			case 'rank-insignia':
				return RankInsignia;
			case 'receipt':
				return Receipt;
			case 'reception':
				return Reception;
			case 'records':
				return Records;
			case 'refresh':
				return Refresh;
			case 'rename':
				return Rename;
			case 'requests':
				return Requests;
			case 'ribbon':
				return Ribbon;
			case 'right-arrow':
				return RightArrow;
			case 'road':
				return Road;
			case 'rocking-chair':
				return RockingChair;
			case 'rosette':
				return Rosette;
			case 'rotas':
				return Rotas;
			case 'rotate-device':
				return RotateDevice;
			case 'rotate-image':
				return RotateImage;
			case 'ruler':
				return Ruler;
			case 'rush':
				return Rush;
			case 'safe-vault':
				return SafeVault;
			case 'safety-beaker':
				return SafetyBeaker;
			case 'safety-boots-ppe':
				return SafetyBootsPpe;
			case 'safety-cone':
				return SafetyCone;
			case 'safety-faceshield-ppe':
				return SafetyFaceshieldPpe;
			case 'safety-goggles-ppe':
				return SafetyGogglesPpe;
			case 'safety-hardhat':
				return SafetyHardhat;
			case 'safety-injury':
				return SafetyInjury;
			case 'safety-slip':
				return SafetySlip;
			case 'safety-washing-ppe':
				return SafetyWashingPpe;
			case 'search':
				return Search;
			case 'security-lock':
				return SecurityLock;
			case 'security-pin':
				return SecurityPin;
			case 'send':
				return Send;
			case 'settings-sliders':
				return SettingsSliders;
			case 'shape-circle':
				return ShapeCircle;
			case 'shape-pentagon':
				return ShapePentagon;
			case 'shape-square':
				return ShapeSquare;
			case 'shape-triangle-up':
				return ShapeTriangleUp;
			case 'share':
				return Share;
			case 'shield':
				return Shield;
			case 'shifts':
				return Shifts;
			case 'shredder':
				return Shredder;
			case 'signal-loss':
				return SignalLoss;
			case 'signal':
				return Signal;
			case 'signature':
				return Signature;
			case 'skull':
				return Skull;
			case 'social-facebook':
				return SocialFacebook;
			case 'social-instagram':
				return SocialInstagram;
			case 'social-linkedin':
				return SocialLinkedin;
			case 'social-twitter':
				return SocialTwitter;
			case 'social-youtube':
				return SocialYoutube;
			case 'software-chrome':
				return SoftwareChrome;
			case 'sort-ascending':
				return SortAscending;
			case 'sort-descending':
				return SortDescending;
			case 'spanner':
				return Spanner;
			case 'stamp':
				return Stamp;
			case 'star-filled':
				return StarFilled;
			case 'star':
				return Star;
			case 'steam':
				return Steam;
			case 'stethoscope':
				return Stethoscope;
			case 'stop':
				return Stop;
			case 'stopwatch':
				return Stopwatch;
			case 'suitcase':
				return Suitcase;
			case 'sun':
				return Sun;
			case 'switcher':
				return Switcher;
			case 'syringe':
				return Syringe;
			case 'table-grid':
				return TableGrid;
			case 'table':
				return Table;
			case 'tachograph':
				return Tachograph;
			case 'tag':
				return Tag;
			case 'tally':
				return Tally;
			case 'target':
				return Target;
			case 'tasklist':
				return Tasklist;
			case 'technology-laptop':
				return TechnologyLaptop;
			case 'temperature':
				return Temperature;
			case 'employee-terminated':
				return EmployeeTerminated;
			case 'terminated-dismissed':
				return TerminatedDismissed;
			case 'thumbs-down':
				return ThumbsDown;
			case 'thumbs-up':
				return ThumbsUp;
			case 'tick-circle':
				return TickCircle;
			case 'tick-thick':
				return TickThick;
			case 'tick-thin':
				return TickThin;
			case 'ticket-stub':
				return TicketStub;
			case 'time-card-report':
				return TimeCardReport;
			case 'timeline-history':
				return TimelineHistory;
			case 'timezones':
				return Timezones;
			case 'toil-add':
				return ToilAdd;
			case 'toil':
				return Toil;
			case 'tooth':
				return Tooth;
			case 'train':
				return Train;
			case 'training-events':
				return TrainingEvents;
			case 'translation-languages':
				return TranslationLanguages;
			case 'trash':
				return Trash;
			case 'tree':
				return Tree;
			case 'turbo-talent':
				return TurboTalent;
			case 'umbrella':
				return Umbrella;
			case 'unpaid':
				return Unpaid;
			case 'up-arrow':
				return UpArrow;
			case 'update':
				return Update;
			case 'upload':
				return Upload;
			case 'user-add':
				return UserAdd;
			case 'user-avatar':
				return UserAvatar;
			case 'user-id':
				return UserId;
			case 'user-remove':
				return UserRemove;
			case 'user':
				return User;
			case 'users':
				return Users;
			case 'vacuum-cleaner':
				return VacuumCleaner;
			case 'verified':
				return Verified;
			case 'video-controls-pause':
				return VideoControlsPause;
			case 'video-controls-play-circle':
				return VideoControlsPlayCircle;
			case 'video-controls-play':
				return VideoControlsPlay;
			case 'virus':
				return Virus;
			case 'visibility-none':
				return VisibilityNone;
			case 'visibility':
				return Visibility;
			case 'voucher':
				return Voucher;
			case 'wallet':
				return Wallet;
			case 'watch':
				return Watch;
			case 'xing':
				return Xing;
			case 'zoom-in':
				return ZoomIn;
			case 'zoom-out':
				return ZoomOut;
			default:
				return CalendarDates;
		}
	};

	const DynamicIcon = getIcon();

	return (
		<DynamicIcon
			size={iconSize(size)}
			{...props}
			className={cn(className)}
		/>
	);
};

export default Icon;
